import React from "react";
import { Grid, Paper, Typography, Button } from "@mui/material";
import { useFormikContext } from "formik";

const PhotosForm = () => {
  const { values, setFieldValue } = useFormikContext();
  const fields = [
    { name: "photoCard", label: "Foto do Estudante" },
    { name: "photoDocumentFront", label: "Frente do Documento" },
    { name: "photoDocumentBack", label: "Verso do Documento" },
    { name: "photoInstitutionStatement", label: "Comprovante de Matrícula" },
  ];

  return (
    <Grid container spacing={2}>
      {fields.map((field, index) => {
        const value = values[field.name];
        let preview = value instanceof File ? URL.createObjectURL(value) : value;
        return (
          <Grid item xs={12} sm={6} md={3} key={index}>
            <Paper elevation={3} sx={{ p: 1 }}>
              {preview ? (
                <img src={preview} alt={field.label} style={{ width: "100%", height: 200, objectFit: "cover" }} />
              ) : (
                <Typography variant="body2" color="text.secondary" align="center" sx={{ height: 200, display: "flex", alignItems: "center", justifyContent: "center" }}>
                  {field.label}
                </Typography>
              )}
              <Button variant="contained" component="label" fullWidth sx={{ mt: 1 }}>
                Alterar
                <input
                  type="file"
                  hidden
                  accept="image/*"
                  onChange={(e) => {
                    if (e.currentTarget.files && e.currentTarget.files[0]) {
                      setFieldValue(field.name, e.currentTarget.files[0]);
                    }
                  }}
                />
              </Button>
            </Paper>
          </Grid>
        );
      })}
    </Grid>
  );
};

export default PhotosForm;